export default "https://cdn-web.disco.co/default-thumbnail-0592a3ec0f4ba9b720e121478fbccfea.png";